import { Component, Input } from '@angular/core';
import { environment } from '@environments/environment';
import { Router } from '@angular/router';
import { IntlService } from '@progress/kendo-angular-intl';
import { ZonedDate } from "@progress/kendo-date-math";


@Component({
  selector: 'base-card',
  template: `@OVERRIDES`,
  styleUrls: ['./styles/styles-card.css'],
  styles: [`@OVERRIDES`]
})
export class BaseCardComponent {

  @Input() defaultImage: string = environment.assets.DEFAULT_VEHICLE;

  @Input() borderTop!: boolean;  
  
  
  constructor(public intl: IntlService, public router: Router) { 

  }

  public getDate(s: string, show_hour: boolean = false): String {  

      if (s == null || s == '') {
        return '';
      }
      else {
        const tzDate = ZonedDate.fromUTCDate(new Date(s), environment.timezone);
        return this.intl.formatDate(tzDate, `dd-MMM-yyyy${(show_hour) ? ' HH:mm': ''}` );
      }
      
  }

}